import React from 'react';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 mb-12" data-id="element-501">
      <div className="max-w-3xl mx-auto" data-id="element-502">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-503">
          La Solución Única
        </h2>
        <p className="text-lg text-gray-700 mb-6 text-center" data-id="element-504">
          Aquí es donde entra el Método Milhojas Perfecta, creado por Stella
          Pereira.
        </p>
        <div className="space-y-4 mb-8" data-id="element-505">
          <div className="flex items-start gap-3" data-id="element-506">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-507">
              <CheckIcon className="text-green-600" size={18} data-id="element-508" />
            </div>
            <p className="text-gray-700" data-id="element-509">
              Un sistema paso a paso que te guía desde la masa hasta la
              decoración final.
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-510">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-511">
              <CheckIcon className="text-green-600" size={18} data-id="element-512" />
            </div>
            <p className="text-gray-700" data-id="element-513">
              Secretos para que las capas salgan siempre finas, crocantes y
              parejas.
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-514">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-515">
              <CheckIcon className="text-green-600" size={18} data-id="element-516" />
            </div>
            <p className="text-gray-700" data-id="element-517">
              La fórmula exacta para un dulce de leche con la textura ideal.
            </p>
          </div>
          <div className="flex items-start gap-3" data-id="element-518">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-519">
              <CheckIcon className="text-green-600" size={18} data-id="element-520" />
            </div>
            <p className="text-gray-700" data-id="element-521">
              El merengue italiano brillante y firme que resiste horas sin
              caerse.
            </p>
          </div>
        </div>
        <p className="text-lg font-medium text-amber-800 text-center" data-id="element-522">
          Con este método, cualquier persona —aunque nunca haya horneado una
          milhojas— puede lograr un resultado digno de pastelería profesional.
        </p>
      </div>
    </section>;
}